const BUSINESS_ROLES = [
	'Global_Details_Field_BusinessRole1',
	'Global_Details_Field_BusinessRole2',
	'Global_Details_Field_BusinessRole3',
];

export default BUSINESS_ROLES;
